/* nh2-home: reveal-on-scroll for B2B homepage blocks + drag-to-scroll
   on the product showcase. Vanilla, no dependencies. */
(function () {
  'use strict';

  /* Signals the layout's inline failsafe that the reveal script loaded, so it
     does not strip .nh2-js and force everything visible mid-animation. */
  window.__nh2RevealReady = true;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.nh2-fade:not(.is-visible)');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) { el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  function initScroller(root) {
    var scrollers = (root || document).querySelectorAll('[data-nh2-scroller]:not([data-nh2-ready])');
    Array.prototype.forEach.call(scrollers, function (sc) {
      sc.setAttribute('data-nh2-ready', 'true');

      var down = false, startX = 0, startLeft = 0, moved = false;

      sc.addEventListener('mousedown', function (e) {
        down = true;
        moved = false;
        startX = e.pageX - sc.offsetLeft;
        startLeft = sc.scrollLeft;
        sc.style.cursor = 'grabbing';
      });

      sc.addEventListener('mousemove', function (e) {
        if (!down) return;
        var x = e.pageX - sc.offsetLeft;
        var walk = (x - startX) * 1.5;
        if (Math.abs(walk) > 4) moved = true;
        e.preventDefault();
        sc.scrollLeft = startLeft - walk;
      });

      function release() {
        down = false;
        sc.style.cursor = '';
      }
      sc.addEventListener('mouseleave', release);
      sc.addEventListener('mouseup', release);

      /* Suppress the click that ends a drag so cards don't navigate. */
      sc.addEventListener('click', function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      }, true);
    });
  }

  /* Arrow buttons for the image carousel. Steps by one card (card width plus
     the flex gap), and disables the arrows at each end. */
  function initArrows(root) {
    var roots = (root || document).querySelectorAll('[data-nh2-carousel]:not([data-nh2-arrows])');
    Array.prototype.forEach.call(roots, function (el) {
      var track = el.querySelector('[data-nh2-track]');
      var prev = el.querySelector('[data-nh2-prev]');
      var next = el.querySelector('[data-nh2-next]');
      if (!track || !prev || !next) return;
      el.setAttribute('data-nh2-arrows', 'true');

      function step() {
        var card = track.querySelector('.nh2-imgcard');
        if (!card) return track.clientWidth;
        var cs = getComputedStyle(track);
        var gap = parseFloat(cs.columnGap || cs.gap) || 24;
        return card.getBoundingClientRect().width + gap;
      }

      function update() {
        var max = track.scrollWidth - track.clientWidth - 1;
        var atStart = track.scrollLeft <= 0;
        var atEnd = track.scrollLeft >= max;
        prev.disabled = atStart;
        next.disabled = atEnd;
        prev.style.opacity = atStart ? '0' : '';
        next.style.opacity = atEnd ? '0' : '';
        prev.style.pointerEvents = atStart ? 'none' : '';
        next.style.pointerEvents = atEnd ? 'none' : '';
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function boot() {
    initReveal();
    initScroller();
    initArrows();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor: re-init after a section is added or reloaded. */
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    initScroller(e.target);
    initArrows(e.target);
  });
})();
